import httpRequest from "services/httpRequest";

const prefix = "/api/payment";

export const onCreatePayment = async params => {
  return await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: params,
  });
};
